export default "__VITE_ASSET__C4mm3YDJ__"